import {
	EmissionValueAnsweredUnit,
	EmissionValueUnit,
	ProductOrServiceCategory,
} from '@api-client'

const _TRANSPORTATION_UNITS: ReadonlySet<string> = new Set([
	EmissionValueUnit.KGCO2_EQ_KG_KM,
	EmissionValueAnsweredUnit.KGCO2_EQ_KG_KM,
	EmissionValueAnsweredUnit.KGCO2_EQ_LBS_MI,
])

// Determine if we should use "service" terminology.
export const getIsTransportationService = (
	productOrServiceCategory?: ProductOrServiceCategory,
	unit?: EmissionValueUnit | EmissionValueAnsweredUnit
): boolean => {
	if (productOrServiceCategory === ProductOrServiceCategory.TRANSPORTATION) {
		return true
	}

	return !!unit && _TRANSPORTATION_UNITS.has(unit)
}
